import React from 'react';
import FaqSection from 'components/FaqSection';
import GuideSection from 'components/GuideSection';
import Link from 'next/link';
import SideBar from './SideBar';
import {
    HeaderH2,
    HeaderH1,
    Text,
    NextButton,
    ImageBlock
} from 'components/TextBlocks';
import { motion } from 'framer-motion';
import Image from 'next/image';

function Mobile(props) {
    return (
        <>
            <HeaderH1>Mobile app</HeaderH1>
            <Text>
                When you have created an account you can reach your data from
                anywhere either by going to the webapp or downloading the native
                apps. You can find the mobile apps here:
            </Text>
            <Webstore
                image={'/browsers/app_store_icon.png'}
                alt={'App store'}
                text={'App store(iOS - iPhone/iPad)'}
                url={'https://apps.apple.com/se/app/tabextend/id6448757608'}
                unaval={false}
            />
            <Webstore
                image={'/browsers/play_store_icon.png'}
                alt={'Play store'}
                text={'Google Play store(Android)'}
                url={
                    'https://play.google.com/store/apps/details?id=com.aconiti.tabextend'
                }
                unaval={false}
            />
            <NextButton
                cta={'Saves on trial plan'}
                textColor={'#565D65'}
                bg={'#EBECED'}
                page={'/guide/trial-saves'}
            />
        </>
    );
}

Mobile.Layout = SideBar;

export default Mobile;

const Webstore = ({ image, alt, text, url, unaval }) => {
    return (
        <motion.div
            whileHover={{ y: -1 }}
            style={{ maxWidth: '330px', pointerEvents: unaval ? 'none' : '' }}
        >
            <Link href={url} target="_blank">
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginTop: '36px',
                        marginBottom: '36px',
                        opacity: unaval ? '0.6' : '1'
                    }}
                >
                    <Image
                        src={image}
                        width={35}
                        height={35}
                        alt={text}
                    ></Image>
                    <p
                        style={{
                            marginLeft: '12px',
                            fontSize: '1.125rem',
                            fontWeight: '500'
                        }}
                    >
                        {text}
                    </p>
                    {!unaval && <OpenIcon />}
                </div>
            </Link>
        </motion.div>
    );
};

export const OpenIcon = () => {
    return (
        <svg
            height="20"
            width="20"
            fill="none"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
            style={{ marginLeft: '8px' }}
        >
            <path
                d="M11 3C10.4477 3 10 3.44772 10 4C10 4.55228 10.4477 5 11 5H13.5858L7.29289 11.2929C6.90237 11.6834 6.90237 12.3166 7.29289 12.7071C7.68342 13.0976 8.31658 13.0976 8.70711 12.7071L15 6.41421V9C15 9.55228 15.4477 10 16 10C16.5523 10 17 9.55228 17 9V4C17 3.44772 16.5523 3 16 3H11Z"
                fill={'#0C92A0'}
            />
            <path
                d="M5 5C3.89543 5 3 5.89543 3 7V15C3 16.1046 3.89543 17 5 17H13C14.1046 17 15 16.1046 15 15V12C15 11.4477 14.5523 11 14 11C13.4477 11 13 11.4477 13 12V15H5V7L8 7C8.55228 7 9 6.55228 9 6C9 5.44772 8.55228 5 8 5H5Z"
                fill={'#0C92A0'}
            />
        </svg>
    );
};
